import { render, staticRenderFns } from "./table-actions.vue?vue&type=template&id=2edbc9d2&scoped=true&"
import script from "./table-actions.vue?vue&type=script&lang=js&"
export * from "./table-actions.vue?vue&type=script&lang=js&"
import style0 from "./table-actions.vue?vue&type=style&index=0&id=2edbc9d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edbc9d2",
  null
  
)

export default component.exports